import isEmpty from 'lodash/isEmpty.js';
import merge from 'lodash/merge.js';
import QuizBuilder from '@/components/quiz-builder/QuizBuilder.vue';
import { ModalService } from '@/services/ModalService.js';
import BaseQuiz from '@/store/modules/base/BaseQuiz.js';
import EdverumTable from '@/store/utilities/EdverumTable.js';
import Quiz from './Quiz.js';

const collectionHelpers = EdverumTable.collection('quiz');

/**
 * @param parent
 * @param props
 * @returns {BModalComponent}
 */
const _openModal = ({ parent, props }) => {
    return ModalService.open({
        component: QuizBuilder,
        customClass: 'quiz-builder-container',
        fullScreen: true,
        parent,
        props,
        scroll: 'keep',
        canCancel: [],
    });
};

export default merge(BaseQuiz({ name: 'QuizBuilder', item: Quiz }), {
    namespaced: true,

    state: {
        api: {
            quizzes: '/api/quizzes',
            questions: '/api/questions',
        },
        question_types: [
            {
                name: 'True/False',
                value: 'true_false',
            },
            {
                name: 'Multiple Choice Single Answer',
                value: 'multiple_choice',
            },
            {
                name: 'Multiple Choice Multiple Answer',
                value: 'multiple_choice_multiple_answer',
            },
            {
                name: 'Free Form',
                value: 'free_form',
            },
        ],
        quiz_list: null,
        openEditor: null,
        modalIsOpen: false,
        modalQuizUuid: null,
        modalQuizIsNew: true,
    },

    getters: {
        ...collectionHelpers.getters,
    },

    actions: {
        editQuiz: async (context, { quiz_id, parent }) => {
            if (isEmpty(context.getters.get(quiz_id))) {
                await context.dispatch('hydrateQuiz', { quiz_id, parent });
            }

            // DEPRECATED
            // const modal = openModal({
            //     props: { uuid: quiz_id, isNew: false },
            //     parent,
            // });

            context.commit('SET_MODAL_QUIZ_UUID', quiz_id);
            context.commit('SET_MODAL_QUIZ_IS_NEW', false);
            context.commit('SET_MODAL_IS_OPEN', true);
        },

        hydrateQuiz: async (context, { quiz_id, parent = null }) => {
            if (isEmpty(context.getters.get(quiz_id))) {
                const quiz = await context.dispatch('fetch', {
                    route: 'quizzes',
                    type: 'single',
                    query: '?include=tags,groups,courseCodes',
                    id: quiz_id,
                });

                const parentUuid = parent && parent?.uuid ? parent.uuid : null;

                await context.dispatch('Quizzes/add', quiz, { root: true });

                await context.dispatch('add', {
                    ...quiz,
                    uuid: quiz_id,
                    activity_uuid: parentUuid,
                    parent,
                });

                const questions = await context.dispatch('fetch', {
                    route: 'questions',
                    type: 'all',
                    id: quiz_id,
                    query: `?filter[quiz_id]=${quiz_id}&show_correct=true`,
                });

                await context.dispatch(`QuizBuilder/${quiz_id}/hydrateQuestions`, { questions }, { root: true });
            }
        },

        setQuizList: async context => {
            // TODO: Raise per page limit

            context.commit('TOGGLE_LOADING');

            const data = await context
                .dispatch('fetchAll', {
                    endpoint: 'quizzes',
                    raw: { per_page: 100 },
                })
                .then(resp => {
                    context.commit('TOGGLE_LOADING');

                    return resp.data.data;
                })
                .catch(_error => {
                    context.commit('TOGGLE_LOADING');
                });

            context.commit('SET', { field: 'quiz_list', value: data });
        },

        /**
         * @param context
         */
        closeEditor: context => {
            if (context.state.openEditor) {
                context.state.openEditor.close();

                // Deprecated
                context.commit('CACHE_EDITOR', null);

                context.commit('SET_MODAL_IS_OPEN', false);
            }
        },
    },

    mutations: {
        AUTO_SAVE_ANSWER: () => {
            // used to trigger autosave
        },

        AUTO_SAVE_QUESTION: () => {
            // used to trigger autosave
        },

        AUTO_SAVE_QUIZ: () => {
            // used to trigger autosave
        },

        AUTO_SAVE_REMOVE: () => {
            // used to trigger autosave
        },

        AUTO_SAVE_REORDER: () => {
            // used to trigger autosave
        },

        SET: (state, { field, value }) => {
            state[field] = value;
        },

        /**
         * @param state
         * @param modal
         * @constructor
         */
        CACHE_EDITOR: (state, modal) => {
            state.openEditor = modal;
        },

        SET_MODAL_IS_OPEN: (state, isOpen) => {
            state.modalIsOpen = isOpen;
        },

        SET_MODAL_QUIZ_UUID: (state, quizUuid) => {
            state.modalQuizUuid = quizUuid;
        },

        SET_MODAL_QUIZ_IS_NEW: (state, isNew) => {
            state.modalQuizIsNew = isNew;
        },
    },
});
